import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';

export const Datenschutz = () => {
  return (
    <div className="min-h-screen flex flex-col" data-testid="datenschutz-page">
      <Navigation />
      
      <main className="flex-1 pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-[#003366] mb-8">Datenschutzerklärung</h1>
          
          <div className="prose prose-lg max-w-none text-slate-700 space-y-6">
            
            {/* 1. Datenschutz auf einen Blick */}
            <section>
              <h2 className="text-2xl font-semibold text-[#003366] mt-8 mb-4">1. Datenschutz auf einen Blick</h2>
              
              <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">Allgemeine Hinweise</h3>
              <p>
                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren 
                personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene 
                Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. 
                Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter 
                diesem Text aufgeführten Datenschutzerklärung.
              </p>

              <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">Datenerfassung auf dieser Website</h3>
              <p>
                <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
                Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen 
                Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
              </p>
              <p className="mt-4">
                <strong>Wie erfassen wir Ihre Daten?</strong><br />
                Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei 
                kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben. Andere 
                Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch 
                unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, 
                Betriebssystem oder Uhrzeit des Seitenaufrufs).
              </p>
              <p className="mt-4">
                <strong>Wofür nutzen wir Ihre Daten?</strong><br />
                Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu 
                gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.
              </p>
              <p className="mt-4">
                <strong>Welche Rechte haben Sie bezüglich Ihrer Daten?</strong><br />
                Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und 
                Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein 
                Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine 
                Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung 
                jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten 
                Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. 
                Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.
              </p>
            </section>

            {/* 2. Allgemeine Hinweise und Pflichtinformationen */}
            <section>
              <h2 className="text-2xl font-semibold text-[#003366] mt-8 mb-4">2. Allgemeine Hinweise und Pflichtinformationen</h2>
              
              <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">Datenschutz</h3>
              <p>
                Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. 
                Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den 
                gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
              </p>
              <p className="mt-4">
                Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. 
                Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können. 
                Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir 
                sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht.
              </p>

              <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">Hinweis zur verantwortlichen Stelle</h3>
              <p>
                Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
              </p>
              <p className="mt-4 whitespace-pre-line">
                KayaGroup{'\n'}
                Sinan Kaya / Gürsel Kaya GbR{'\n'}
                Am Schwalbengraben 17{'\n'}
                35584 Wetzlar{'\n'}
                Deutschland{'\n'}
                {'\n'}
                Telefon: <a href="tel:+4916092653278" className="text-[#00BFFF] hover:text-[#003366]">+49 160 92653278</a>{'\n'}
                E-Mail: <a href="mailto:fa.kayaclean@gmail.com" className="text-[#00BFFF] hover:text-[#003366]">fa.kayaclean@gmail.com</a>
              </p>
              <p className="mt-4">
                Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder 
                gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen 
                Daten (z.B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
              </p>

              <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">Speicherdauer</h3>
              <p>
                Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt 
                wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die 
                Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen 
                oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, 
                sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer 
                personenbezogenen Daten haben.
              </p>

              <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
              <p>
                Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. 
                Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit 
                der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
              </p>

              <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">Beschwerderecht bei der zuständigen Aufsichtsbehörde</h3>
              <p>
                Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei 
                einer Aufsichtsbehörde zu. Das Beschwerderecht besteht unbeschadet anderweitiger 
                verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.
              </p>

              <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">Recht auf Datenübertragbarkeit</h3>
              <p>
                Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung 
                eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem 
                gängigen, maschinenlesbaren Format aushändigen zu lassen.
              </p>

              <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">Auskunft, Löschung und Berichtigung</h3>
              <p>
                Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf 
                unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft 
                und Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung 
                oder Löschung dieser Daten.
              </p>

              <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">Recht auf Einschränkung der Verarbeitung</h3>
              <p>
                Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten 
                zu verlangen. Hierzu können Sie sich jederzeit an uns wenden.
              </p>
            </section>

            {/* 3. Datenerfassung auf dieser Website */}
            <section>
              <h2 className="text-2xl font-semibold text-[#003366] mt-8 mb-4">3. Datenerfassung auf dieser Website</h2>
              
              <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">Cookies</h3>
              <p>
                Unsere Internetseiten verwenden so genannte „Cookies". Cookies sind kleine Datenpakete 
                und richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für 
                die Dauer einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem 
                Endgerät gespeichert. Session-Cookies werden nach Ende Ihres Besuchs automatisch gelöscht. 
                Permanente Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese selbst löschen 
                oder eine automatische Löschung durch Ihren Webbrowser erfolgt.
              </p>
              <p className="mt-4">
                Cookies können von uns (First-Party-Cookies) oder von Drittunternehmen stammen 
                (sog. Third-Party-Cookies). Third-Party-Cookies ermöglichen die Einbindung bestimmter 
                Dienstleistungen von Drittunternehmen innerhalb von Webseiten.
              </p>
              <p className="mt-4">
                Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert 
                werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte 
                Fälle oder generell ausschließen sowie das automatische Löschen der Cookies beim 
                Schließen des Browsers aktivieren.
              </p>

              <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">Kontaktformular</h3>
              <p>
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem 
                Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung 
                der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
              </p>
              <p className="mt-4">
                <strong>Folgende Daten können bei der Nutzung des Kontaktformulars verarbeitet werden:</strong>
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Name</li>
                <li>E-Mail-Adresse</li>
                <li>Telefonnummer</li>
                <li>Nachricht / Anfragetext</li>
              </ul>
              <p className="mt-4">
                Diese Daten werden ausschließlich zur Beantwortung Ihrer Anfrage verwendet und nicht 
                an Dritte weitergegeben. Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 
                lit. b DSGVO (Vertragsanbahnung) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse).
              </p>
              <p className="mt-4">
                Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns zur 
                Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für 
                die Datenspeicherung entfällt.
              </p>

              <h3 className="text-xl font-semibold text-slate-800 mt-6 mb-3">Anfrage per E-Mail oder Telefon</h3>
              <p>
                Wenn Sie uns per E-Mail oder Telefon kontaktieren, wird Ihre Anfrage inklusive aller 
                daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung 
                Ihres Anliegens bei uns gespeichert und verarbeitet. Diese Daten geben wir nicht ohne 
                Ihre Einwilligung weiter.
              </p>
              <p className="mt-4">
                Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, 
                sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung 
                vorvertraglicher Maßnahmen erforderlich ist.
              </p>
            </section>

            {/* 4. WhatsApp Kontakt */}
            <section>
              <h2 className="text-2xl font-semibold text-[#003366] mt-8 mb-4">4. Kontakt über WhatsApp</h2>
              <p>
                Sie haben die Möglichkeit, uns über den Messenger-Dienst WhatsApp zu kontaktieren. 
                WhatsApp ist ein Dienst der WhatsApp Ireland Limited, 4 Grand Canal Square, Grand Canal 
                Harbour, Dublin 2, Irland, einer Tochtergesellschaft der Meta Platforms, Inc.
              </p>
              <p className="mt-4">
                Wenn Sie uns über WhatsApp kontaktieren, werden Ihre Nachricht sowie Ihre Telefonnummer 
                und ggf. Ihr Name an uns übermittelt. Wir verwenden diese Daten ausschließlich zur 
                Bearbeitung Ihrer Anfrage.
              </p>
              <p className="mt-4">
                <strong>Hinweis:</strong> WhatsApp verarbeitet personenbezogene Daten (z.B. Telefonnummern, 
                Metadaten, Nachrichteninhalte) gemäß den eigenen Datenschutzrichtlinien. Diese Datenverarbeitung 
                liegt außerhalb unseres Einflussbereichs. Weitere Informationen zur Datenverarbeitung durch 
                WhatsApp finden Sie in der Datenschutzerklärung von WhatsApp: 
                <a href="https://www.whatsapp.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-[#00BFFF] hover:text-[#003366] ml-1">
                  https://www.whatsapp.com/legal/privacy-policy
                </a>
              </p>
              <p className="mt-4">
                Die Nutzung von WhatsApp erfolgt auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) 
                bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer effizienten Kommunikation 
                mit unseren Kunden).
              </p>
            </section>

            {/* 5. Ihre Rechte */}
            <section>
              <h2 className="text-2xl font-semibold text-[#003366] mt-8 mb-4">5. Ihre Rechte nach DSGVO</h2>
              <p>
                Als betroffene Person haben Sie gemäß der Datenschutz-Grundverordnung (DSGVO) folgende Rechte:
              </p>
              <ul className="list-disc list-inside mt-4 space-y-2">
                <li><strong>Auskunftsrecht (Art. 15 DSGVO):</strong> Sie können Auskunft über Ihre von uns verarbeiteten personenbezogenen Daten verlangen.</li>
                <li><strong>Recht auf Berichtigung (Art. 16 DSGVO):</strong> Sie können die Berichtigung unrichtiger oder die Vervollständigung Ihrer bei uns gespeicherten personenbezogenen Daten verlangen.</li>
                <li><strong>Recht auf Löschung (Art. 17 DSGVO):</strong> Sie können die Löschung Ihrer bei uns gespeicherten personenbezogenen Daten verlangen, soweit keine gesetzlichen Aufbewahrungspflichten entgegenstehen.</li>
                <li><strong>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO):</strong> Sie können die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten verlangen.</li>
                <li><strong>Recht auf Datenübertragbarkeit (Art. 20 DSGVO):</strong> Sie können verlangen, dass wir Ihnen Ihre personenbezogenen Daten in einem strukturierten, gängigen und maschinenlesbaren Format übermitteln.</li>
                <li><strong>Widerspruchsrecht (Art. 21 DSGVO):</strong> Sie können jederzeit gegen die Verarbeitung Ihrer personenbezogenen Daten Widerspruch einlegen.</li>
                <li><strong>Recht auf Widerruf der Einwilligung (Art. 7 Abs. 3 DSGVO):</strong> Sie können eine einmal erteilte Einwilligung jederzeit widerrufen.</li>
                <li><strong>Beschwerderecht (Art. 77 DSGVO):</strong> Sie können sich bei einer Aufsichtsbehörde beschweren, wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten gegen die DSGVO verstößt.</li>
              </ul>
            </section>

            {/* 6. Aktualität */}
            <section className="pb-8">
              <h2 className="text-2xl font-semibold text-[#003366] mt-8 mb-4">6. Aktualität und Änderung dieser Datenschutzerklärung</h2>
              <p>
                Diese Datenschutzerklärung ist aktuell gültig und hat den Stand: {new Date().toLocaleDateString('de-DE', { month: 'long', year: 'numeric' })}.
              </p>
              <p className="mt-4">
                Durch die Weiterentwicklung unserer Website und Angebote oder aufgrund geänderter 
                gesetzlicher bzw. behördlicher Vorgaben kann es notwendig werden, diese Datenschutzerklärung 
                zu ändern. Die jeweils aktuelle Datenschutzerklärung kann jederzeit auf dieser Website 
                abgerufen werden.
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Datenschutz;
